import React from 'react';
import Layout from '../components/Layout';
import SaleChannelList from '../components/SaleChannelList';

const SaleChannels = () => {
  return (
    <Layout>
      <SaleChannelList />
    </Layout>
  );
};

export default SaleChannels;
